module.exports = __webpack_public_path__ + "img/fast.95166b4.jpg";